import { PostalAreasColumns } from "../constants";
import _ from "lodash";

/**
 * @description Get filter options for table columns
 * @param {Array<any>} countries - List of available countries
 * @param {MunicipalityColumns} columnKey - Current column key
 * @returns {Array<any>} - Returns country names or codes
 */
export const getCountryFilters = (
  countries: Array<any>,
  columnKey: PostalAreasColumns
): Array<any> => {
  try {
    if (Array.isArray(countries)) {
      if (columnKey == PostalAreasColumns.COUNTRY) {
        return countries?.map(({ name }) => ({
          text: name,
          value: name,
        }));
      } else {
        return countries?.map(({ code }) => ({
          text: code,
          value: code,
        }));
      }
    } else {
      return [];
    }
  } catch (error) {
    return [];
  }
};

/**
 * @description Remove unnecessary data
 * @param {string} text - Text to be cleaned up
 * @returns {string} - cleaned text
 */
export const clearText = (text: string): string => {
  try {
    return text?.trim()?.toLowerCase();
  } catch (error) {
    return "";
  }
};
